import { Component, EventEmitter, Output } from '@angular/core';

/**
 * Helpdesk card — substitui os antigos `<div id="cardAtendimentoPergunta">`
 * + `<div id="cardFormulario">` que viviam no `app-support-button` e eram
 * acionados por jQuery. Agora o conteúdo é um componente Angular único com
 * estado interno (`mode: 'ask' | 'form'`), montado num CDK Overlay pelo
 * `HelpdeskOverlayService`. Mantém as classes/ids que o script Zammad
 * depende (`.open-zammad-chat`, `#zammad-feedback-form`) — esses âncoras
 * continuam no `app-support-button`, em formato `display: none`, pra não
 * quebrar a inicialização da biblioteca externa.
 */
@Component({
  selector: 'app-helpdesk-card',
  templateUrl: './helpdesk-card.component.html',
  styleUrls: ['./helpdesk-card.component.scss'],
})
export class HelpdeskCardComponent {
  /** Modo do card: 'ask' = pergunta inicial (chat sim/não); 'form' = card
   *  de orientação por e-mail + abrir ticket. */
  mode: 'ask' | 'form' = 'ask';

  /** Emite quando o card deve ser fechado (Não/fechar/abrir ticket/abrir chat). */
  @Output() requestClose = new EventEmitter<void>();

  /** "Sim, quero chat" — dispara o widget Zammad via o âncora hidden
   *  `.open-zammad-chat` que `app-support-button` mantém no DOM. Se 500ms
   *  depois o chat não estiver visível (`.js-chat-open` ausente), assume
   *  que o Zammad está fora do ar e troca pro modo 'form'. */
  onClickYes(): void {
    const anchor = document.querySelector<HTMLElement>('.open-zammad-chat');
    anchor?.click();
    setTimeout(() => {
      if (!document.querySelector('.js-chat-open')) {
        this.mode = 'form';
      } else {
        this.requestClose.emit();
      }
    }, 500);
  }

  /** "Não" / "Fechar" — só fecha. */
  onClickNo(): void {
    this.requestClose.emit();
  }

  /** "Abrir ticket" — dispara o âncora hidden `#zammad-feedback-form`
   *  (mantido em `app-support-button`) e fecha o card. */
  onOpenTicket(): void {
    document.getElementById('zammad-feedback-form')?.click();
    this.requestClose.emit();
  }
}
